// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".X-NL0NNd1ze4GgXt59R1Ew\\=\\={min-width:54px}", "",{"version":3,"sources":["webpack://./resources/client/src/app/modules/order/components/firstStage.module.scss"],"names":[],"mappings":"AAAA,4BAAO,cAAc","sourcesContent":[".input{min-width:54px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "X-NL0NNd1ze4GgXt59R1Ew=="
};
export default ___CSS_LOADER_EXPORT___;
